import React from 'react';
import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import styles from './GSDSectionTitle.module.css';

const GsdSectionTitle = (props) => (
  <div className={styles.GsdSectionTitle}>
   <Grid className={styles.titleStyle} >
      <Typography 
        variant='h6'
        sx={{
          color: '#333',
          fontWeight: 600,
          fontSize: '20px',
          letterSpacing: '-0.3px',
          paddingLeft: '12px'
        }}
      >
        {props.title}
      </Typography>
    </Grid>
  </div>
);

export default GsdSectionTitle;
